import React, { Component } from 'react';

import ScrollToNextButton from './ScrollToNextButton';

class HeroSection extends Component {

  constructor(props) {
    super(props);

    if (props.imageSrc) {
      this.style = {
        backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.2)), url(${props.imageSrc})`,
        backgroundPosition: `${props.imagePosX || 'left'} ${props.imagePosY || 'center'}`,
      };
    } else if (props.color) {
      this.style = { backgroundColor: props.color };
    }
  }

  render() {
    return (
      <section className="hero-section" style={this.style}>
        {(this.props.h1 || this.props.h2) && (
          <div className="hero-content">
            {this.props.h1 && <h1>{this.props.h1}</h1>}
            {this.props.h2 && <h2>{this.props.h2}</h2>}
          </div>
        )}
        <ScrollToNextButton></ScrollToNextButton>
      </section>
    );
  }

}

export default HeroSection;



// WEBPACK FOOTER //
// ./src/components/HeroSection.js